import { emailBerichten } from "../EmailTemplates";
import { AXIOS_GET, AXIOS_POST, AXIOS_UPDATE } from "../server/api/crud";



const {
  setMailRoomsLoad,
  setMailMessage,
  setMailMessageItemsFilterLoad,
  setMailMessageItemsLoad,
  setMailUnreadCount,
} = require("../redux/mailSlice");

export const fetchMailUnreadCount = async (user, dispatch) => {
  try {
    if (!user?.id) return;
    const response = await AXIOS_GET("mailbox/mailmessage/unread-count/total");
    const unreadCount = Number(response?.data?.data?.unread_count || 0);
    dispatch(setMailUnreadCount(unreadCount));
  } catch (error) {
    if (error.code === 'ECONNABORTED' || error.message === 'Request aborted' || error.message === 'canceled') {
      return;
    }
    console.error("Error fetching unread mail count", error);
  }
};

export const fetchMailRoomsPage = async (user, mailMessage = null, limit = 16, offset = 0, query = "") => {
  if (!user?.id) return [];
  const authorId = mailMessage?.author_id || user?.id;
  const safeSearch = encodeURIComponent(query || "");
  const response = await AXIOS_GET(
    `mailbox/mailmessageById/filter/${user?.id}/${authorId}?limit=${limit}&offset=${offset}&search=${safeSearch}`
  );
  return response?.data?.data || [];
};

export const fetchMailRooms = async (user,dispatch,mailMessage = null,limit,offset,query) => {
    try {
      if (!user?.id) return;
      const rooms = await fetchMailRoomsPage(user, mailMessage, limit, offset, query);

      dispatch(setMailRoomsLoad(rooms));
      fetchMailUnreadCount(user, dispatch);

      
      if(!mailMessage){
        dispatch(setMailMessage(rooms[0]));
      }
     
    } catch (error) {
      // Ignore aborted/cancelled requests (e.g. navigation, reload)
      if (error.code === 'ECONNABORTED' || error.message === 'Request aborted' || error.message === 'canceled') {
        return;
      }
      if (error?.response?.status === 404) {
        console.warn("Mailrooms not found for this user (404); session may be invalid.");
        return;
      }
      if (error?.response?.status === 403) {
        console.warn("Mailbox request forbidden for current session/user context.");
      }
      console.error("Error fetching mailrooms", error);
    }
  };

  export const fetchMailRoomsChange = async (user,dispatch,mailMessage = null,limit,offset,query) => {
    try {
      if (!user?.id) return;
      const rooms = await fetchMailRoomsPage(user, mailMessage, limit, offset, query);
      dispatch(setMailRoomsLoad(rooms));
      fetchMailUnreadCount(user, dispatch);
      const findRoom = rooms.find((item) => item.id == mailMessage.id);
      //dispatch(setMailMessage(findRoom));
    } catch (error) {
      if (error.code === 'ECONNABORTED' || error.message === 'Request aborted' || error.message === 'canceled') {
        return;
      }
      console.error("Error fetching mailrooms", error);
    }
  };


  export const seenMessage = async (user,mailMessage,dispatch) => {
    try {
      const response = await AXIOS_UPDATE(`mailbox/message/seen`,mailMessage.id,{});

     
      if(response.status == 200){

        fetchMailUnreadCount(user, dispatch);
      }

    } catch (error) {
      if (error.code === 'ECONNABORTED' || error.message === 'Request aborted' || error.message === 'canceled') {
        return;
      }
      console.error("Error fetching mailrooms", error);
    }
  };

  export const markUnreadMessagesRead = async (user, dispatch, options = {}) => {
    try {
      if (!user?.id) return null;
      const payload = options?.beforeDate ? { beforeDate: options.beforeDate } : {};
      const response = await AXIOS_UPDATE("mailbox/message/seen", "bulk", payload);
      await fetchMailUnreadCount(user, dispatch);
      return response;
    } catch (error) {
      if (error.code === 'ECONNABORTED' || error.message === 'Request aborted' || error.message === 'canceled') {
        return null;
      }
      console.error("Error marking unread mail messages as read", error);
      throw error;
    }
  };


  export const fetchMailMessages = async (user,dispatch) => {
    try {
      if (!user?.id) return;
      const response = await AXIOS_GET(`mailbox/messageItemsByUser/${user?.id}`);
      dispatch(setMailMessageItemsLoad(response.data.data));
      dispatch(setMailMessageItemsFilterLoad(response.data.data));
    } catch (error) {
      console.error("Error fetching mail messages", error);
    }
  };

  /**
   * Load all messages for one thread (both participants).
   * Opening a conversation must use this — not only messageItemsByUser —
   * otherwise received messages stay invisible until the viewer sends a reply.
   */
  export const fetchMailThreadItems = async (threadId, dispatch) => {
    try {
      if (!threadId) return [];
      const response = await AXIOS_GET(`mailbox/mailmessage/${threadId}/items`);
      const items = Array.isArray(response?.data?.data) ? response.data.data : [];
      dispatch(setMailMessageItemsFilterLoad(items));
      dispatch(setMailMessageItemsLoad(items));
      return items;
    } catch (error) {
      if (error.code === 'ECONNABORTED' || error.message === 'Request aborted' || error.message === 'canceled') {
        return [];
      }
      console.error("Error fetching mail thread items", error);
      return [];
    }
  };
